import mathHelper from './mathHelper';

// Pure normalization logic for the PlanningDetail edit wizard, ported verbatim from the old
// (deleted) PlanningDetailItemEditBox popup (CD-5199).
export class planningEditHelper {
  // Noon-anchored local Date; dates older than ~20 years are treated as unset and become today.
  static toNoonDate(oldDate) {
    let date = oldDate instanceof Date ? oldDate : new Date(oldDate);
    const twentyYearsAgo = new Date(new Date().getFullYear() - 20, new Date().getMonth(), new Date().getDate());
    if (date < twentyYearsAgo) date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0);
  }

  // Builds a 4-slot rate array (NaN/missing -> 0); when the slots don't sum to 100, the fallback wins.
  static toRateArray(r1, r2, r3, r4, fallback: number[]) {
    const rate = [isNaN(r1) ? 0 : r1, isNaN(r2) ? 0 : r2, isNaN(r3) ? 0 : r3, isNaN(r4) ? 0 : r4];
    return mathHelper.Sum(rate) === 100 ? rate : fallback;
  }

  // Sets one tier from raw input (NaN -> 0) and, for tiers 0-2, rebalances the later
  // tiers so the four total 100. Pure: returns a new array, never mutates the input.
  // Ported from the legacy TargetRate component's auto-balance.
  static balanceRateArray(values: number[], index: number, rawValue: string): number[] {
    const next = [...values];
    const parsed = parseInt(rawValue);
    next[index] = isNaN(parsed) ? 0 : parsed;
    if (index < 3) {
      let sum = 0;
      for (let i = 0; i < 4; i++) {
        if (i > index) {
          next[i] = Math.max(Math.ceil((100 - sum) / (4 - i)), 0);
        }
        sum += next[i];
      }
    }
    return next;
  }
}

export default planningEditHelper;
